import React, { useState, useEffect } from "react";
import Input from "../Common/CustomInput";
import api from "../../setupMiddleware";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import { getUser, hasPermission } from "../../Utils/auth";
import PlusIcon from "../../assets/icons/plus";
import Popup from "../Common/Popup";
import FileUpload from "../Common/FileUpload";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { documentTypes, getFileType } from "../../Utils/getUserUtitls";
import { FaFilePdf } from "react-icons/fa";
import { Link } from "react-router-dom";
import CustomSelect from "../Common/CustomSelect";
import Textarea from "../Common/Textarea";

const Profile = () => {
  const loading = useApiLoader();
  // const [roleData, setRoleData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  // const [departmentData, setDepartmentData] = useState([]);
  // const [locationData, setLocationData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [document, setDocument] = useState({
    document_type: "",
    file_path: [],
    other_name: "",
  });

  const [uploadOpen, setUploadOpen] = useState(false);

  const userData = getUser();

  const documentOptions = documentTypes.filter((doc) =>
    doc.location_id.includes(userData?.location_id)
  );

  const { document_type, file_path, other_name } = document;

  console.log("document", document);
  // const designationOptions = designationData?.map((des) => ({
  //   label: des.title,
  //   value: des.id,
  // }));

  // const roleOptions = roleData?.map((ro) => ({
  //   label: ro.name,
  //   value: ro.id,
  // }));

  // const departmentOptions = departmentData?.map((dep) => ({
  //   label: dep.name,
  //   value: dep.id,
  // }));

  // const locationOptions = locationData?.map((loc) => ({
  //   label: loc.name,
  //   value: loc.id,
  // }));

  // const genderOptions = [
  //   {
  //     label: "Male",
  //     value: "male",
  //   },
  //   {
  //     label: "Female",
  //     value: "female",
  //   },
  //   {
  //     label: "Other",
  //     value: "other",
  //   },
  // ];

  const [employee, setEmployee] = useState();

  const getProfileInfo = async () => {
    await api.get(`/api/user/${userData?.id}`).then((res) => {
      if (res && res.status === 200) {
        setEmployee(res.data?.data);
      }
    });
  };

  const uploadDocument = async () => {
    const formData = new FormData();
    formData.append("user_id", userData?.id);
    formData.append("document_type", document_type);
    if (file_path && file_path.length > 0) {
      formData.append("file_path", file_path[0]);
    }
    try {
      await api.post(`/api/employee-documents`, formData).then((res) => {
        if (res && res.status === 201) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          // navigate("/employees");
        }
      });
    } catch (err) {
      if (err) {
        toast.error(err.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      }
    }
  };

  console.log(documentData);
  const getAllDocuments = async () => {
    api
      .get(`/api/employee-documents/${userData?.id}`)
      .then((res) => {
        if (res && res.status === 200) {
          setDocumentData(res.data?.data);
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  };

  // const getAllDepartments = async () => {
  //   api.get("/api/departments").then((res) => {
  //     if (res && res.status === 200) {
  //       setDepartmentData(res.data);
  //     }
  //   });
  // };

  // const getAllLocation = async () => {
  //   api.get("/api/locations").then((res) => {
  //     if (res && res.status === 200) {
  //       setLocationData(res.data?.data);
  //     }
  //   });
  // };

  useEffect(() => {
    getProfileInfo();
    getAllDocuments();
    // getAllDepartments();
    // getAllLocation();
  }, []);

  const hasFile = Array.isArray(file_path) ? file_path.length > 0 : !!file_path; // works for string, null, undefined

  const hasDocumentType = !!document_type;
  const isOther = document_type === "Other";
  const hasOtherName = !!other_name;

  const isDisabled = !(
    (hasDocumentType && hasFile) ||
    (isOther && hasOtherName && hasFile)
  );
  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Profile
          </span>
          <span className="block text-sm text-[#142b70]/50">
            See and edit details
          </span>
        </p>

        {/* Right Button */}
        <div className="flex gap-4">
          <button
            onClick={() => setEdit(!edit)}
            className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
          >
            {edit ? "Cancel" : "Edit Details"}
          </button>
          <Popup
            isOpen={uploadOpen}
            onClose={() => setUploadOpen(false)}
            title="Upload Document"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <div className="relative">
                  <FileUpload
                    label="Select Document"
                    accept=".jpg,.pdf,.doc,.docx"
                    multiple={false}
                    onChange={(file) =>
                      setDocument({ ...document, file_path: file })
                    }
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2 mb-4">
                <p className="text-sm text-[#142b70]/80">Document Name</p>
                <div className="relative">
                  <CustomSelect
                    options={documentOptions}
                    placeholder="Document Name"
                    value={document_type}
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setDocument({
                        ...document,
                        document_type: op.value,
                      })
                    }
                  />
                </div>
              </div>
              {document_type === "Other" && (
                <div className="flex flex-col gap-2 -mt-3 mb-4">
                  <p className="text-sm text-[#142b70]/80">
                    Other Document Name
                  </p>
                  <div className="relative">
                    <Input
                      placeholder="Other Document Name"
                      value={other_name}
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) =>
                        setDocument({
                          ...document,
                          other_name: op.value,
                        })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setUploadOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={uploadDocument}
                disabled={isDisabled}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Upload
              </button>
            </div>
          </Popup>
        </div>
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto p-8 relative rounded-3xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col lg:flex-row flex-grow justify-start items-start gap-[60px]">
            {/* Form Col 1*/}
            <div className="flex flex-col flex-grow gap-6 w-full">
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <div className="relative">
                    <img
                      src={employee?.employee_image}
                      className="w-40 h-40 rounded-full mx-auto mb-8 object-cover"
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">First Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter First name"
                      value={employee?.first_name}
                      disable={true}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Last Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Last name"
                      value={employee?.last_name}
                      disable={true}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Username</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Username"
                      value={employee?.username}
                      disable={true}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Email</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Email"
                      value={employee?.email}
                      disable={true}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Phone Number</p>
                  <div className="relative">
                    <Input
                      type="number"
                      placeholder="Enter Phone Number"
                      value={employee?.phone}
                      disable={!edit}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          phone: `${e.target.value}`,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Date of Birth</p>
                  <div className="relative">
                    <Input
                      type="date"
                      placeholder="Enter DOB"
                      value={employee?.dob}
                      disable={true}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Date of Joining</p>
                  <div className="relative">
                    <Input
                      type="date"
                      placeholder="Enter Date of Joining"
                      value={employee?.joining_date}
                      disable={true}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Gender</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Gender"
                      value={employee?.gender}
                      disable={true}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Form Col 2 */}
            <div className="flex flex-col flex-grow gap-6 w-full">
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Role</p>
                  <Input
                    type="text"
                    value={employee?.role?.name}
                    placeholder="Role"
                    disable={true}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Designation</p>
                  <Input
                    type="text"
                    value={employee?.designation?.title}
                    placeholder="Designation"
                    disable={true}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Grade</p>
                  <Input
                    type="text"
                    value={employee?.grade?.title}
                    placeholder="Grade"
                    disable={true}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Department</p>
                  <Input
                    type="text"
                    value={employee?.department?.name}
                    placeholder="Department"
                    disable={true}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Team Leader</p>
                  <Input
                    type="text"
                    value={employee?.tl_id === 0 ? "N/A" : employee?.tl?.name}
                    placeholder="Team Leader"
                    disable={true}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Location</p>
                  <Input
                    type="text"
                    value={employee?.location?.name}
                    placeholder="Location"
                    disable={true}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Nationality</p>
                  <Input
                    type="text"
                    value={employee?.nationality}
                    placeholder="Nationality"
                    disable={true}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Permanent Address</p>
                  <Textarea
                    value={employee?.permanent_address}
                    placeholder="Permanent Address"
                    disable={true}
                    rows={2}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Current Address</p>
                  <Textarea
                    value={employee?.current_address}
                    placeholder="Current Address"
                    disable={true}
                    rows={2}
                  />
                </div>
              </div>
              {/* <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Password</p>
                  <div className="relative">
                    <Input
                      type={passwordShown ? "text" : "password"}
                      placeholder="Enter Password"
                      value={employee?.password}
                      onChange={(e) =>
                        setEmployee({ ...employee, password: e.target.value })
                      }
                    />
                    <div
                      className="absolute right-4 top-4 cursor-pointer"
                      onClick={handleClickShowPassword}
                    >
                      {passwordShown ? (
                        <FiEye color="#142b70" />
                      ) : (
                        <FiEyeOff color="#142b70" />
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Confirm Password</p>
                  <div className="relative">
                    <Input
                      type={passwordShown ? "text" : "password"}
                      placeholder="Enter Password again"
                      value={employee?.con_password}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          con_password: e.target.value,
                        })
                      }
                    />
                    <div
                      className="absolute right-4 top-4 cursor-pointer"
                      onClick={handleClickShowPassword}
                    >
                      {passwordShown ? (
                        <FiEye color="#142b70" />
                      ) : (
                        <FiEyeOff color="#142b70" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <PasswordRules
                  minchar={minchar}
                  upcase={upcase}
                  lowcase={lowcase}
                  number={number}
                  special={special}
                />
              </div> */}
            </div>
          </div>
          {/* Footer */}
          <div className="flex justify-end gap-4 mt-8">
            <button
              className={`px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium ${
                edit ? "block" : "hidden"
              }`}
              // onClick={handleAddEmployee}
            >
              Update
            </button>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default Profile;
